'use strict';

exports.__esModule = true;
exports.LocationSubscriber = exports.LocationBroadcast = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBroadcast = require('react-broadcast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint react/prop-types: 0*/
var NAME = 'location';

var LocationBroadcast = function LocationBroadcast(_ref) {
  var children = _ref.children;
  var value = _ref.value;
  return _react2.default.createElement(_reactBroadcast.Broadcast, { channel: NAME, value: value, children: children });
};

var LocationSubscriber = function LocationSubscriber(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(_reactBroadcast.Subscriber, { channel: NAME, children: children });
};

exports.LocationBroadcast = LocationBroadcast;
exports.LocationSubscriber = LocationSubscriber;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/locationBroadcast.js
 ** module id = 45
 ** module chunks = 0
 **/